import React, { Component } from 'react';


export default class AppointmentTypeDropdown extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.availableEventTypes.length == 0) {
      return this.renderEmptyDropdown();
    }
    return this.renderFilledInDropdown();
  }

  renderEmptyDropdown() {
    return (
      <div>
        <select name={this.props.name} onChange={this.props.onChange}>
        </select>
        <hr />
      </div>
    )
  }

  renderFilledInDropdown() {
    return (
      <div>
          <select name={this.props.name} onChange={this.props.onChange}>
            {this.props.availableEventTypes.map((value, index) => {
              if (value.id == this.props.selectedOption) {
                return <option key={value.id} value={value.id} selected="selected">{value.name}</option>
              }
              return <option key={value.id} value={value.id}>{value.name}</option>
            })
            }
          </select>
          <hr />
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AppointmentTypeDropdown.js